import {useState, useCallback, useEffect, useRef} from 'react';
import classNames from 'classnames';
import { useNavigate, useParams } from 'react-router';
import { useMemoizedFn } from 'ahooks';
import toast from 'react-hot-toast';
import { hasClass } from '@/utils/dom';
import { isSufeExamClient } from '@/utils/examClient';
import Bus from '@/utils/bus';
import AIContant from '@/utils/aiContant';
import { logCount } from '@/utils/logger/arms-config';
import i18n from '@/locales/init'; 
import {useAppSelector} from '@/stores/index';
import { useAppDispatch } from '@/stores/index';
// import { useAppDispatch } from '@/stores';
// import { toggleShowNotePanel } from '@/stores/slice/listening';
import {setAudioPlayTime, setPlayIndex, setPlayStatus, setRecordAudioProgress} from '@/stores/slice/listening';
import { useModulePoints } from '@/hooks/useModulePoints';
import {AudioSvg, BellSvg, MenuSvg,NetSvg, NoteSvg} from '../../Svg/index';
import Audio from '../Audio';
import FinishDialog from '../FinishDialog';
import { checkHasPoints, checkUserPointsOnly } from '../Points/userPoints';
import style from './index.module.less';

const pointsMap = {
  r: 70,
  l: 69,
  w: 71,
};

interface IProps {
  time: number;
  isAI: boolean;
  isSubject: boolean;
  tabSubjectHandle: (val: boolean)=> void;
  isListen: boolean;
  loadAnswered: boolean;
  updateTimeHandle: (val: number) => void;
  submitHandle: (val: () => void) => void;
  noteHandle: () => void;
  audioSrc: string;
  course: 'r' | 'l' | 'w';
}

export default function TopBar(props: IProps) {
  const {time: timeProp, isAI, isSubject, tabSubjectHandle, isListen, loadAnswered, updateTimeHandle, submitHandle, noteHandle, audioSrc, course} = props;
  const automaticSubmissionOnly = !isAI && isSufeExamClient();

  const dispatch = useAppDispatch();
  const userId = useAppSelector((state) => state.user.userId);
  const { recordId } = useParams();
  const pointsInit = useAppSelector(state => state.points.initialized);

  const navigate = useNavigate();
  // const showNotePanel = () => {
  //   dispatch(toggleShowNotePanel());
  // };

  const {audioIndex, audioSrcArr, audioStartPlayTime, recordAudioProgressArr, pageDataIndex} = useAppSelector(state=> state.listening);

  const [show, setShow] = useState(false);

  const cancelHandle = useCallback(()=> {
    setShow(false);
  }, []);

  const showDialogHandle = useCallback(()=> {
    if (automaticSubmissionOnly) return;
    logCount('Click_Finish_Button');
    setShow(true);
  }, [automaticSubmissionOnly]);

  const time = useRef(timeProp * 60);
  const timeRef = useRef<HTMLElement | null>(null);
  const hoverRef = useRef<HTMLElement | null>(null);
  const timeBoxRef = useRef<HTMLDivElement | null>(null);
  const pointsInfo = useModulePoints(pointsMap[course] || 0);

  const autoSubmit = useMemoizedFn((cb: () => void) => {
    if (automaticSubmissionOnly && (!loadAnswered || time.current > 0)) return;
    if (!checkHasPoints(pointsInfo.modulePoints, () => {

      setTimeout(() => {
        if (time.current <= 0) {
          if (!checkUserPointsOnly(pointsInfo.modulePoints)) {
            toast.error('您无法提交批改，模考时间已过，直接退出!');
            navigate(`/mockstart/${recordId}`, {replace: true});
          } else {
            setTimeout(() => {
              autoSubmit(cb);
            }, 10);
          }
        }

      }, 3000);

    })) {
      return;
    }
    submitHandle(cb);
  });
  
  useEffect(() => {
    let blinkCount = 0;
    let startBlink = false;
    const startTime = Date.now();
    function convertSeconds(seconds: number) {
      const minutes = Math.floor(seconds / 60);
      const remainingSeconds = Math.floor(seconds % 60);
      // 开启开关
      if (minutes === 10 && remainingSeconds === 0) {
        startBlink = true;
      }

      if ( startBlink && blinkCount <= 12) {
        if (blinkCount % 2 === 1) {
          if (timeBoxRef.current) {
            timeBoxRef.current.classList.add(style.red);
          }
        } else {
          if (timeBoxRef.current) {
            timeBoxRef.current.classList.remove(style.red);
          }
        }
        blinkCount++;
      }

      if (seconds <= 300) {
        if (timeBoxRef.current) {
          if (!hasClass(timeBoxRef.current, style.red)) {
            timeBoxRef.current.classList.add(style.red);
          }
        }
        
      }

      if (timeBoxRef.current && seconds < 90) {
        timeBoxRef.current.classList.add(style.showSecond);
      }

      
      let remainingSecondsStr = String(remainingSeconds);
      if (remainingSeconds < 10) {
        remainingSecondsStr = '0' + remainingSeconds;
      }

      if (timeRef.current && hoverRef.current) {
        timeRef.current.textContent = (remainingSeconds === 0 ? minutes : minutes + 1) + ' minutes remaining';
        hoverRef.current.textContent = `${minutes}:${remainingSecondsStr} remaining`;
      }
    }
    let timer:number |NodeJS.Timeout;
    if (loadAnswered && !isAI) {
      time.current = timeProp;
      timer = setInterval(() => {
        const t = Date.now();
        time.current = timeProp - (t - startTime) / 1000;
        updateTimeHandle(Math.floor(time.current));
        if (time.current <= 0 && pointsInit) {
          clearInterval(timer);
          autoSubmit(() => {});
          return;
        }
        convertSeconds(time.current);
      }, 1000);
    }
    
    return () => {
      if (!isAI) {
        clearInterval(timer);
      }
    };
  }, [loadAnswered, isListen, pointsInit]);

  const audioRef = useRef<HTMLAudioElement | null>(null);

  const handleEnded = () => {
    dispatch(setPlayIndex(audioIndex + 1));
  };

  
  // 刷新继续播放
  const [initShowPlayDialog, setInitShowPlayDialog] = useState(false);
  const initShow = useRef(false);
  const freshContinuePlay = () => {
    setInitShowPlayDialog(false);
    (document.getElementById('audio') as HTMLAudioElement)?.play();
  };
  const initPlayTime = useRef(false);
  useEffect(() => {
    if (audioRef.current && audioSrcArr.length && audioSrcArr[audioIndex]) {
      audioRef.current.src = audioSrcArr[audioIndex];
      if (!initPlayTime.current && audioStartPlayTime !== 0) {
        audioRef.current.currentTime = audioStartPlayTime;
        initPlayTime.current = true;
      }

      audioRef.current.play().catch((err) => {
        if (!initShow.current && err.code === 0) {
          setInitShowPlayDialog(true);
          initShow.current = true;
        }
        console.log('浏览器播放权限');
      });
    }
  }, [audioIndex, audioSrcArr, audioStartPlayTime]);

  const backHandle = useCallback(() => {
    navigate(`/mockstart/${recordId}`);
  }, [navigate, recordId]);

  const playStateCallBack = (val: boolean) => {
    dispatch(setPlayStatus(val ? 'play' : 'pause'));
    if (isAI && !val) {
      Bus.publish(AIContant.AUDIO_STOP, undefined);
    }
  };

  const upDateAudioPlayTime = () => {
    if (!isAI && audioRef.current) {
      dispatch(setAudioPlayTime(audioRef.current.currentTime));
    }
  };

  const saveRecordProgress = (val: {duration: number; currentTime: number;}) => {
    dispatch(setRecordAudioProgress(val));
  };
  
  return (
    <div className={style.topBar}>
      <div className={style.topLeft}>
        <div className={style.info}>
          <div className={style.studentId}>{i18n.t('common.dauyan_zkn_xxxxxx', { user_id: userId })}</div>
          {
            isAI ? <div className={style.timeBox}>
              &nbsp;
            </div> : <div className={style.timeBox} ref={timeBoxRef}>
              <span className={style.time} ref={timeRef}></span>
              <span className={style.minutes} ref={hoverRef}></span>
            </div>
          }
        </div>
        
        {
          !isAI && isListen ? <div className={style.audioBox}>
            <audio id="audio" ref={audioRef} onTimeUpdate={upDateAudioPlayTime} onEnded={handleEnded}></audio>
            <div className={style.audioStatusBox}>
              <i className={style.audioIcon}>{AudioSvg}</i>
              <span className={style.audioStatus}>Audio is playing</span>
            
            </div>
          </div> : null
        }

        {
          isAI && isListen ? <div className={style.tabList}>
            <div className={classNames(style.tabTitle, isSubject ? style.active: '')} onClick={() => tabSubjectHandle(true)}>{i18n.t('common.dauyan_following_search_result_v')}</div>
            <div className={classNames(style.tabTitle, isSubject ? '' : style.active)} onClick={() => tabSubjectHandle(false)}>{i18n.t('common.dauyan_feedback_origin_essay')}</div>
          </div>
            :
            null
        }
        {
          isAI && isListen ? 
            <Audio src={audioSrc} playStateCallBack={playStateCallBack} recordAudioProgress={recordAudioProgressArr[pageDataIndex]} saveRecordProgress={saveRecordProgress}></Audio> : null
        } 
      </div>
      <div className={style.topRight}>
        
        { isAI ? <button className={style.button} onClick={backHandle}>{i18n.t('common.dauyan_return')}</button> : <button className={style.button} disabled={automaticSubmissionOnly} onClick={showDialogHandle}>{automaticSubmissionOnly ? i18n.t('common.dauyan_exam_auto_submit') : 'Finish test'}</button> }
        <i className={style.icon}>{NetSvg}</i>
        <i className={style.icon}>{BellSvg}</i>
        <i className={style.icon}>{MenuSvg}</i>
        <i className={style.icon} onClick={noteHandle}>{NoteSvg}</i>
      </div>
      { 
        initShowPlayDialog ? <div className={style.playAudioDialog}>
          <div className={style.playBack}></div>
          <div className={style.playPanle}>
            <div className={style.playTitle}>{i18n.t('common.dauyan_play_audio_and_answer')}</div>
            <div className={style.playBtn} onClick={freshContinuePlay}>{i18n.t('common.dauyan_confirm')}</div>
          </div>
        </div> : null
      }
      {!automaticSubmissionOnly && <FinishDialog course={course} show={show} cancel={cancelHandle} submitHandle={autoSubmit}></FinishDialog>}
    </div>
  );
}
